import axios from 'axios';
import API from '@/API';

const storageName = 'sdv.documents';
const state = {
  documents: [],
  totalDocuments: 0,
  documentsTotalStorage: null
};

const getters = {
  getDocumentsTotalStorage(state) {
    updateDocumentsTotalStorageFromStorage(state);
    return state.documentsTotalStorage;
  }
};

const mutations = {
  setDocumentsTotalStorage(state, data) {
    sessionStorage.setItem(storageName, JSON.stringify(data));
    state.documentsTotalStorage = data;
  },
  logout(state) {
    sessionStorage.removeItem(storageName);
    state.documentsTotalStorage = null;
  }
};
const actions = {
  async requestDocuments({ state }, { folderId }) {
    try {
      const response = await axios.get(
        `${API.documents}?folder=${folderId}&all=true`
      );
      state.totalDocuments = response.data.meta.total;
      state.documents = response.data.documents;
    } catch (error) {
      console.error('Error while getting documents: ', error);
    }
  }
};

function updateDocumentsTotalStorageFromStorage(state) {
  let storageDocumentsTotalStorage = JSON.parse(
    sessionStorage.getItem(storageName)
  );
  if (!state.documentsTotalStorage && storageDocumentsTotalStorage) {
    state.documentsTotalStorage = storageDocumentsTotalStorage;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
